(function (angular) {

  angular
    .module("app")
    .controller("pcmlogoutController", ["$scope","pcmtidLoginService","$window", function ($scope,pcmtidLoginService,$window) {
      console.log("logout");
      
      $window.location.href = "";


    }]);
})(window.angular);


// WEBPACK FOOTER //
// ./app/account/pcmtidlogout.controller.js